
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import ProductPicker from '@/components/ProductPicker.vue';

const { config } = api;

@Component({ components: { ProductPicker } })
export default class HomeProduct extends Vue {
  private valid: boolean = false;

  private discounts: Array<{ merchantId: number, productId: string}> = [];

  private pointToCash: Array<{ merchantId: number, productId: string}> = []

  private loading: boolean = false;

  private async submit() {
    const configKey = 'HomeProducts';
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const form = {
        discounts: this.discounts.map((v: { productId: string }) => v.productId),
        pointToCash: this.pointToCash.map((v: { productId: string }) => v.productId),
      };
      const { status } = await config.createOrUpdate(configKey, form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '儲存成功' });
      }
    }
  }

  private setForm(data: any) {
    this.discounts = data?.discounts || [];
    this.pointToCash = data?.pointToCash || [];
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: HomeProduct) => void) => void,
  ) {
    const { data } = await config.getHomeProduct();
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
